invHdApp.
factory('Support', ['$http', function($http) {
    return {
      save: function(data) {
        return $http.post('api/save-support',data);
      }
    };
}]);